export const getSiblings = (elem) => {
  const siblings = [];
  let sibling = elem.parentNode.firstChild;

  for (; sibling; sibling = sibling.nextSibling) {
    if (sibling.nodeType !== 1 || sibling === elem) continue;
    siblings.push(sibling);
  }

  return siblings;
};

//TODO: write universal function for subsequent animations
export const animate = (elem) => {
  const removeAnimation = (element, resolve) => {
    element.removeEventListener(`transitionend`, removeAnimation);
    resolve();
  };

  return new Promise((resolve, reject) => {
    elem.addEventListener(`transitionend`, e => {
      e.stopPropagation();
      removeAnimation(elem, resolve)
    }, false)
  }, false)
};

/**
 * Post data to server
 * @param {array} data
 * @param {String} address
 * @return {Promise}
 */
export const saveData = (data, address) => {
  const options = {
    method: `POST`,
    body: data,
    headers: {
      [`Accept`]: `application/json, application/xml, text/plain, text/html, *.*`
    }
  };

  return fetch(address, options)
    .then((response) => {
      if (!response.ok) {
        throw new Error(`${response.status}: ${response.text}`);
      }
    });
};

/**
 * Load data from server
 * @param {String} source
 * @return {Promise}
 */
export const loadData = (source) => {
  return fetch(source)
    .then((response) => {
      if (response.ok) {
        return response.json();
      } else {
        throw new Error(`${response.status}: ${response.text}`);
      }
    });
};
/**
 * Key press handler
 * @param keyCode
 * @param key
 * @param cb
 */
export const onKeyPressHandler = ({keyCode}, key, cb) => {
  if (keyCode === key) cb();
};

export const youtubeLinkToEmbed = (link) => {
  // zgIuKZJPS_c
  // https://www.youtube.com/watch?v=zgIuKZJPS_c&param=value
  // https://youtu.be/zgIuKZJPS_c?param=value
  // https://www.youtube.com/embed/zgIuKZJPS_c?param=value

  const youtube = 'https://www.youtube.com/embed/';
  const id = link.split('/').pop().split('v=').pop().split(/[?&]/)[0];

  return youtube + id;
};
